module.exports = __webpack_public_path__ + "static/img/DSC02256666(1).ed22ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC02256666(1).jpg
// module id = /oOG
// module chunks = 0